'use client'

import dynamic from 'next/dynamic'

const MenuBar = dynamic(async () => (await import('./menu-bar')).MenuBar, {
  ssr: false,
})

export const MenuBarClient = ({ menuConfig }: any) => {
  return <MenuBar menuConfig={menuConfig} />
}
